import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  IconButton,
} from "@mui/material";
import { Edit } from "@mui/icons-material";

const Preferences = () => {
  const [mappings, setMappings] = useState([]);
  const [orgs, setOrgs] = useState([]);
  const [years, setYears] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    organization: "",
    academicYear: "",
  });

  useEffect(() => {
    fetchMappings();
    fetchOrgs();
    fetchYears();
  }, []);

  const fetchMappings = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get("/users/preferences", {
      headers: { "x-auth-token": token },
    });
    setMappings(res.data);
  };

  const fetchOrgs = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get("/orgs", {
      headers: { "x-auth-token": token },
    });
    setOrgs(res.data);
  };

  const fetchYears = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get("/academic-years", {
      headers: { "x-auth-token": token },
    });
    setYears(res.data);
  };

  const handleOpenEdit = (mapping) => {
    setForm({
      organization: mapping.organization._id,
      academicYear: mapping.academicYear?._id || "",
    });
    setOpen(true);
  };

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    await axios.put(
      "/users/preferences",
      {
        organization: form.organization,
        academicYear: form.academicYear,
      },
      { headers: { "x-auth-token": token } }
    );
    setOpen(false);
    setForm({ organization: "", academicYear: "" });
    fetchMappings();
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Org Settings
      </Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Organization</TableCell>
            <TableCell>Academic Year</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mappings.map((m) => (
            <TableRow key={m.organization._id}>
              <TableCell>{m.organization.name}</TableCell>
              <TableCell>{m.academicYear?.name || "--"}</TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenEdit(m)}>
                  <Edit />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Edit Settings</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal" disabled>
            <InputLabel>Organization</InputLabel>
            <Select value={form.organization} label="Organization">
              {orgs.map((org) => (
                <MenuItem key={org._id} value={org._id}>
                  {org.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>Academic Year</InputLabel>
            <Select
              value={form.academicYear}
              onChange={(e) =>
                setForm({ ...form, academicYear: e.target.value })
              }
              label="Academic Year"
            >
              {years.map((year) => (
                <MenuItem key={year._id} value={year._id}>
                  {year.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Preferences;
